export default __webpack_public_path__ + "static/istqb-1b043e800a580724ad223567f9ea57c0.png";